import styled from 'styled-components';
import MaterialListItem from '@material-ui/core/ListItem';

export const ListItem = styled(MaterialListItem)``;
